import { Product } from "@/types";

export type LinkStatusColor = "default" | "success" | "primary";

export interface LinkStatus {
  label: string;
  color: LinkStatusColor;
  icon: string;
}

export function getLinkStatus(product: Product): LinkStatus {
  if (!product.scrapedProduct) {
    return {
      label: "Not Linked",
      color: "default",
      icon: "solar:link-broken-linear",
    };
  }

  const isPrimary = product.scrapedProductId === product.scrapedProduct.id;

  return isPrimary
    ? { label: "Primary", color: "success", icon: "solar:link-bold" }
    : { label: "Secondary", color: "primary", icon: "solar:link-linear" };
}
